import { Component, h } from 'preact';

class County extends Component {
  constructor() {
    super();

    this.state = { hovered: false };

    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onMouseOver(e) {
    this.setState({ hovered: true });
  }

  onMouseOut(e) {
    this.setState({ hovered: false });
  }

  render(
    { color, feature, geoPath, onHover, onMouseOut, onMouseMove },
    { hovered }
  ) {
    const name = feature.properties.name;
    const fips = feature.properties.fips.slice(2);

    return (
      <g>
        <path
          d={geoPath(feature)}
          fill={color}
          onMouseOver={e => onHover(fips, e)}
          onMouseMove={e => onMouseMove(e)}
          onMouseOut={onMouseOut}
        />
      </g>
    );
  }
}

export default County;



// WEBPACK FOOTER //
// ./components/County.js